import { useContext } from "react";

import { AppContext } from "@/stores/appStore";

/**
 * Decide if we should render the guidance text to perform Chime IDV based on
 * the user's hiring country. We do not want to display the guidance text to
 * the USA/IND based users to avoid raising the IT support contact rate.
 */
export const useShowChimeIdvGuidance = function (): boolean {
  const { state } = useContext(AppContext);
  return !["USA", "IND"].includes(state.hiringCountry ?? "");
};
